// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inner-pop .fleets .list {
  font-size: 16px;
}
.inner-pop .fleets .list .item {
  margin-top: 5px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.inner-pop .fleets .list .item .check {
  display: flex;
  align-items: center;
  align-content: center;
  column-gap: 8px;
  height: 100%;
}
.inner-pop .fleets .list .item .check ion-radio-group {
  display: flex;
}
.inner-pop .fleets .list .item .check .text {
  max-width: 150px;
}
.inner-pop .fleets .list .item .check .text span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.inner-pop .fleets .list .item .check .text small {
  color: var(--rows-color, #5f7d95);
  font-size: 13px;
}
.inner-pop .fleets .list .item .check .name {
  display: flex;
  flex-direction: column;
  column-gap: 5px;
}
.inner-pop .fleets .list .item .--s {
  font-size: 12px;
  cursor: pointer;
}
.inner-pop .fleets .list .item .--s:hover {
  opacity: 0.8;
}
.inner-pop .fleets .list .hide {
  display: none;
}
.inner-pop .fleets .list ion-grid {
  padding: 0 15px;
}
.inner-pop .fleets .list ion-grid.hov:hover {
  background-color: var(--app-main-strong);
  color: white;
}
.inner-pop .fleets .list ion-grid.hov:hover .text small {
  color: white !important;
}
.inner-pop .fleets .list ion-grid ion-row {
  height: 45px;
}
.inner-pop .fleets .add {
  font-weight: 500;
  color: var(--app-contr);
}
.inner-pop .fleets .action {
  display: flex;
  flex-direction: row;
  column-gap: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/popover-fleet/popover-fleet.component.scss"],"names":[],"mappings":"AASC;EACE,eAAA;AARH;AAUG;EACD,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AARF;AAUE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;AARJ;AAUI;EACD,aAAA;AARH;AAWI;EACD,gBAAA;AATH;AAWG;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AATL;AAYG;EACE,iCAAA;EACA,eAAA;AAVL;AAcI;EACD,aAAA;EACA,sBAAA;EACA,eAAA;AAZH;AAgBE;EACE,eAAA;EACA,eAAA;AAdJ;AAgBI;EACD,YAAA;AAdH;AAmBG;EACD,aAAA;AAjBF;AAoBG;EACD,eAAA;AAlBF;AAqBI;EACD,wCAAA;EACA,YAAA;AAnBH;AAqBK;EACC,uBAAA;AAnBN;AAyBE;EACE,YAAA;AAvBJ;AA4BC;EACE,gBAAA;EACA,uBAAA;AA1BH;AA6BC;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AA3BH","sourcesContent":["*{\n\n}\n\n.inner-pop{\n  //padding: 10px;\n\n  .fleets{\n\n\t.list{\n\t  font-size: 16px;\n\n\t  .item{\n\t\tmargin-top: 5px;\n\t\tmargin-bottom: 5px;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\twidth: 100%;\n\n\t\t.check{\n\t\t  display: flex;\n\t\t  align-items: center;\n\t\t  align-content: center;\n\t\t  column-gap: 8px;\n\t\t  height: 100%;\n\n\t\t  ion-radio-group{\n\t\t\tdisplay: flex;\n\t\t  }\n\n\t\t  .text{\n\t\t\tmax-width: 150px;\n\n\t\t\tspan{\n\t\t\t  overflow: hidden;\n\t\t\t  text-overflow: ellipsis;\n\t\t\t  white-space: nowrap;\n\t\t\t}\n\n\t\t\tsmall{\n\t\t\t  color: var(--rows-color, #5f7d95);\n\t\t\t  font-size: 13px;\n\t\t\t}\n\t\t  }\n\n\t\t  .name{\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tcolumn-gap: 5px;\n\t\t  }\n\t\t}\n\n\t\t.--s{\n\t\t  font-size: 12px;\n\t\t  cursor: pointer;\n\n\t\t  &:hover{\n\t\t\topacity: 0.8;\n\t\t  }\n\t\t}\n\t  }\n\n\t  .hide{\n\t\tdisplay: none;\n\t  }\n\n\t  ion-grid{\n\t\tpadding: 0 15px;\n\n\t\t&.hov{\n\t\t  &:hover{\n\t\t\tbackground-color: var(--app-main-strong);\n\t\t\tcolor: white;\n\t\t\t.text {\n\t\t\t  small{\n\t\t\t  \tcolor: white !important;\n\t\t\t  }\n\t\t\t}\n\t\t  }\n\t\t}\n\n\t\tion-row{\n\t\t  height: 45px;\n\t\t}\n\t  }\n\t}\n\n\t.add{\n\t  font-weight: 500;\n\t  color: var(--app-contr)\n\t}\n\n\t.action{\n\t  display: flex;\n\t  flex-direction: row;\n\t  column-gap: 5px;\n\t}\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
